import Multiselect from 'vue-multiselect'
import { createHOCc } from 'vue-hoc'

export const multiselectDefaults = createHOCc({
  props: [
    'placeholder',
    'tagPlaceholder',
    'showLabels',
    'searchable',
    'multiple',
    'closeOnSelect',
    'hideSelected',
    'taggable',
    'maxHeight',
    'openDirection',
  ],
}, {
  props: {
    openDirection() {
      return this.openDirection || 'bottom'
    },
    tagPlaceholder() {
      return this.tagPlaceholder || ''
    },
    showLabels() {
      return this.showLabels || false
    },
    searchable() {
      return this.searchable || false
    },
    multiple() {
      return this.multiple || false
    },
    closeOnSelect() {
      return this.closeOnSelect || true
    },
    hideSelected() {
      return this.hideSelected || false
    },
    taggable() {
      return this.taggable || false
    },
    placeholder() {
      return this.placeholder || ''
    },
    maxHeight() {
      return this.maxHeight
    },
  },
})

export default multiselectDefaults(Multiselect)
